import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import artistStyles from "views/Artists/Styles/ArtistStyles.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import SectionCarousel from "./Sections/DonBendelCarousel.jsx";
import SectionNavbars from "views/Components/Sections/SectionNavbars.jsx";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";


class Components extends React.Component {
  render() {

    const { classes} = this.props;

    return (     
      
      <div> 
        <SectionNavbars/>  
                 
        <Parallax image={require("assets/img/Eide/Cows.jpg")}>       

          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title}>Eide Fine Art</h1>
                  <h4><b>With its display of contemporary ceramics, paintings, and sculpture, the Eide Art Gallery 465 is one of Northern Arizona's finest art venues. Works by recognized fine artists from the United States and other countries are showcased in the gallery. The adobe complex overlooks the Verde River in Lower Sycamore Canyon.</b></h4>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)} >
          <h3 className ={classNames(classes.subtitle)} style={artistStyles.bioText}>
              Don Bendel

             </h3>
          <p style={artistStyles.bioText}>Donald V. Bendel was a familiar figure in the ceramic arts before he passed away in 2019. He hosted NCECA, the most recognized ceramics conference, at Northern Arizona University in the early seventies. The Bendel-Burner, which he invented for gas-fired kilns, received international attention in the late 70’s. 
          For 30 years he and Joel Eide, Former N.A.U. Art Museum Director, organized national and international conferences and workshops in ceramics. At the University Dr. Bendel developed an internationally recognized wood-firing program under the influence and assistance of the late Yukio Yamamoto, a Japanese treasure.
          </p>

          <SectionCarousel/>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(Components);



// WEBPACK FOOTER //
// ./src/views/Artists/DonBendel.jsx